;(function (window, document, $, undefined) {

    /* {{{ ./vk/static_src/assets/md5.js */

    /*
     * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
     * Digest Algorithm, as defined in RFC 1321.
     * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
     * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
     * Distributed under the BSD License
     * See http://pajhome.org.uk/crypt/md5 for more info.
     */

    var Md5 = function () {
        /*
         * Configurable variables. You may need to tweak these to be compatible with
         * the server-side, but the defaults work in most cases.
         */
        var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase        */
        var b64pad = "="; /* base-64 pad character. "=" for strict RFC compliance   */

        /*
         * These are the functions you'll usually want to call
         * They take string arguments and return either hex or base-64 encoded strings
         */
        function hex_md5(s) {
            return rstr2hex(rstr_md5(str2rstr_utf8(s)));
        }
        function b64_md5(s) {
            return rstr2b64(rstr_md5(str2rstr_utf8(s)));
        }
        function any_md5(s, e) {
            return rstr2any(rstr_md5(str2rstr_utf8(s)), e);
        }
        function hex_hmac_md5(k, d) {
            return rstr2hex(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
        }
        function b64_hmac_md5(k, d) {
            return rstr2b64(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
        }
        function any_hmac_md5(k, d, e) {
            return rstr2any(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)), e);
        }

        /*
         * Perform a simple self-test to see if the VM is working
         */
        function md5_vm_test() {
            return hex_md5("abc").toLowerCase() == "900150983cd24fb0d6963f7d28e17f72";
        }

        /*
         * Calculate the MD5 of a raw string
         */
        function rstr_md5(s) {
            return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
        }

        /*
         * Calculate the HMAC-MD5, of a key and some data (raw strings)
         */
        function rstr_hmac_md5(key, data) {
            var bkey = rstr2binl(key);
            if (bkey.length > 16) bkey = binl_md5(bkey, key.length * 8);

            var ipad = Array(16),
                opad = Array(16);
            for (var i = 0; i < 16; i++) {
                ipad[i] = bkey[i] ^ 0x36363636;
                opad[i] = bkey[i] ^ 0x5C5C5C5C;
            }

            var hash = binl_md5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
            return binl2rstr(binl_md5(opad.concat(hash), 512 + 128));
        }

        /*
         * Convert a raw string to a hex string
         */
        function rstr2hex(input) {
            try {
                hexcase;
            } catch (e) {
                hexcase = 0;
            }
            var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
            var output = "";
            var x;
            for (var i = 0; i < input.length; i++) {
                x = input.charCodeAt(i);
                output += hex_tab.charAt(x >>> 4 & 0x0F) + hex_tab.charAt(x & 0x0F);
            }
            return output;
        }

        /*
         * Convert a raw string to a base-64 string
         */
        function rstr2b64(input) {
            try {
                b64pad;
            } catch (e) {
                b64pad = '';
            }
            var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            var output = "";
            var len = input.length;
            for (var i = 0; i < len; i += 3) {
                var triplet = input.charCodeAt(i) << 16 | (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) | (i + 2 < len ? input.charCodeAt(i + 2) : 0);
                for (var j = 0; j < 4; j++) {
                    if (i * 8 + j * 6 > input.length * 8) output += b64pad;else output += tab.charAt(triplet >>> 6 * (3 - j) & 0x3F);
                }
            }
            return output;
        }

        /*
         * Convert a raw string to an arbitrary string encoding
         */
        function rstr2any(input, encoding) {
            var divisor = encoding.length;
            var i, j, q, x, quotient;

            /* Convert to an array of 16-bit big-endian values, forming the dividend */
            var dividend = Array(Math.ceil(input.length / 2));
            for (i = 0; i < dividend.length; i++) {
                dividend[i] = input.charCodeAt(i * 2) << 8 | input.charCodeAt(i * 2 + 1);
            }

            /*
             * Repeatedly perform a long division. The binary array forms the dividend,
             * the length of the encoding is the divisor. Once computed, the quotient
             * forms the dividend for the next step. All remainders are stored for later
             * use.
             */
            var full_length = Math.ceil(input.length * 8 / (Math.log(encoding.length) / Math.log(2)));
            var remainders = Array(full_length);
            for (j = 0; j < full_length; j++) {
                quotient = Array();
                x = 0;
                for (i = 0; i < dividend.length; i++) {
                    x = (x << 16) + dividend[i];
                    q = Math.floor(x / divisor);
                    x -= q * divisor;
                    if (quotient.length > 0 || q > 0) quotient[quotient.length] = q;
                }
                remainders[j] = x;
                dividend = quotient;
            }

            /* Convert the remainders to the output string */
            var output = "";
            for (i = remainders.length - 1; i >= 0; i--) {
                output += encoding.charAt(remainders[i]);
            }return output;
        }

        /*
         * Encode a string as utf-8.
         * For efficiency, this assumes the input is valid utf-16.
         */
        function str2rstr_utf8(input) {
            var output = "";
            var i = -1;
            var x, y;

            while (++i < input.length) {
                /* Decode utf-16 surrogate pairs */
                x = input.charCodeAt(i);
                y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
                if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
                    x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
                    i++;
                }

                /* Encode output as utf-8 */
                if (x <= 0x7F) output += String.fromCharCode(x);else if (x <= 0x7FF) output += String.fromCharCode(0xC0 | x >>> 6 & 0x1F, 0x80 | x & 0x3F);else if (x <= 0xFFFF) output += String.fromCharCode(0xE0 | x >>> 12 & 0x0F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);else if (x <= 0x1FFFFF) output += String.fromCharCode(0xF0 | x >>> 18 & 0x07, 0x80 | x >>> 12 & 0x3F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
            }
            return output;
        }

        /*
         * Encode a string as utf-16
         */
        function str2rstr_utf16le(input) {
            var output = "";
            for (var i = 0; i < input.length; i++) {
                output += String.fromCharCode(input.charCodeAt(i) & 0xFF, input.charCodeAt(i) >>> 8 & 0xFF);
            }return output;
        }

        function str2rstr_utf16be(input) {
            var output = "";
            for (var i = 0; i < input.length; i++) {
                output += String.fromCharCode(input.charCodeAt(i) >>> 8 & 0xFF, input.charCodeAt(i) & 0xFF);
            }return output;
        }

        /*
         * Convert a raw string to an array of little-endian words
         * Characters >255 have their high-byte silently ignored.
         */
        function rstr2binl(input) {
            var output = Array(input.length >> 2);
            for (var i = 0; i < output.length; i++) {
                output[i] = 0;
            }for (var i = 0; i < input.length * 8; i += 8) {
                output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << i % 32;
            }return output;
        }

        /*
         * Convert an array of little-endian words to a string
         */
        function binl2rstr(input) {
            var output = "";
            for (var i = 0; i < input.length * 32; i += 8) {
                output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
            }return output;
        }

        /*
         * Calculate the MD5 of an array of little-endian words, and a bit length.
         */
        function binl_md5(x, len) {
            /* append padding */
            x[len >> 5] |= 0x80 << len % 32;
            x[(len + 64 >>> 9 << 4) + 14] = len;

            var a = 1732584193;
            var b = -271733879;
            var c = -1732584194;
            var d = 271733878;

            for (var i = 0; i < x.length; i += 16) {
                var olda = a;
                var oldb = b;
                var oldc = c;
                var oldd = d;

                a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
                d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
                c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
                b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
                a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
                d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
                c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
                b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
                a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
                d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
                c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
                b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
                a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
                d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
                c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
                b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

                a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
                d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
                c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
                b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
                a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
                d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
                c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
                b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
                a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
                d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
                c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
                b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
                a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
                d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
                c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
                b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

                a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
                d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
                c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
                b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
                a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
                d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
                c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
                b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
                a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
                d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
                c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
                b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
                a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
                d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
                c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
                b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

                a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
                d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
                c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
                b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
                a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
                d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
                c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
                b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
                a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
                d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
                c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
                b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
                a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
                d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
                c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
                b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

                a = safe_add(a, olda);
                b = safe_add(b, oldb);
                c = safe_add(c, oldc);
                d = safe_add(d, oldd);
            }
            return Array(a, b, c, d);
        }

        /*
         * These functions implement the four basic operations the algorithm uses.
         */
        function md5_cmn(q, a, b, x, s, t) {
            return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
        }
        function md5_ff(a, b, c, d, x, s, t) {
            return md5_cmn(b & c | ~b & d, a, b, x, s, t);
        }
        function md5_gg(a, b, c, d, x, s, t) {
            return md5_cmn(b & d | c & ~d, a, b, x, s, t);
        }
        function md5_hh(a, b, c, d, x, s, t) {
            return md5_cmn(b ^ c ^ d, a, b, x, s, t);
        }
        function md5_ii(a, b, c, d, x, s, t) {
            return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
        }

        /*
         * Add integers, wrapping at 2^32. This uses 16-bit operations internally
         * to work around bugs in some JS interpreters.
         */
        function safe_add(x, y) {
            var lsw = (x & 0xFFFF) + (y & 0xFFFF);
            var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
            return msw << 16 | lsw & 0xFFFF;
        }

        /*
         * Bitwise rotate a 32-bit number to the left.
         */
        function bit_rol(num, cnt) {
            return num << cnt | num >>> 32 - cnt;
        }

        function Md5() {
            this._data = '';
        }

        Md5.prototype.update = function (data, enc) {
            enc = enc || 'binary';
            switch (enc) {
                case 'binary':
                case 'utf8':
                case 'ascii':
                    this._data += data;
                    break;
                default:
                    throw new Error('unsupported encoding: ' + enc);
            }
            return this;
        };

        Md5.prototype.digest = function (enc) {
            enc = enc || 'binary';
            switch (enc) {
                case 'binary':
                    return rstr_md5(this._data);
                    break;
                case 'hex':
                    return rstr2hex(rstr_md5(this._data));
                    break;
                case 'base64':
                    return rstr2b64(rstr_md5(this._data));
                    break;
                default:
                    throw new Error('unsupported encoding: ' + enc);
            }
        };

        return Md5;
    }();

    /* ./vk/static_src/assets/md5.js }}} */

    /* {{{ ./vk/static_src/assets/sasl.js */

    var Sasl = function () {
        /**
         * DIGEST-MD5 `Mechanism` constructor.
         *
         * This class implements the DIGEST-MD5 SASL mechanism.
         *
         * References:
         *  - [RFC 2831](http://tools.ietf.org/html/rfc2831)
         *
         * @api public
         */
        function Mechanism(options) {
            options = options || {};
            this._genNonce = options.genNonce || genNonce(32);
        }

        Mechanism.prototype.name = 'DIGEST-MD5';
        Mechanism.prototype.clientFirst = false;

        /**
         * Encode a response using given credential.
         *
         * Options:
         *  - `username`
         *  - `password`
         *  - `host`
         *  - `serviceType`
         *  - `authzid`   authorization identity (optional)
         *
         * @param {Object} cred
         * @api public
         */
        Mechanism.prototype.response = function (cred) {
            // TODO: Implement support for subsequent authentication.  This requires
            //       that the client be able to store username, realm, nonce,
            //       nonce-count, cnonce, and qop values from prior authentication.
            //       The impact of this requirement needs to be investigated.
            //
            //       See RFC 2831 (Section 2.2) for further details.

            // TODO: Implement support for auth-int and auth-conf, as defined in RFC
            //       2831 sections 2.3 Integrity Protection and 2.4 Confidentiality
            //       Protection, respectively.
            //
            //       Note that supporting this functionality has implications
            //       regarding the negotiation of security layers via SASL.  Due to
            //       the fact that TLS has largely superseded this functionality,
            //       implementing it is a low priority.

            var uri = cred.serviceType + '/' + cred.host;
            if (cred.serviceName && cred.host !== cred.serviceName) {
                uri += '/' + serviceName;
            }
            var realm = cred.realm || this._realm || '',
                cnonce = this._genNonce(),
                nc = '00000001',
                qop = 'auth',
                ha1,
                ha2,
                digest;

            var str = '';
            str += 'username="' + cred.username + '"';
            if (realm) {
                str += ',realm="' + realm + '"';
            };
            str += ',nonce="' + this._nonce + '"';
            str += ',cnonce="' + cnonce + '"';
            str += ',nc=' + nc;
            str += ',qop=' + qop;
            str += ',digest-uri="' + uri + '"';

            if (cred.authzid) {
                ha1 = md5(md5(cred.username + ":" + realm + ":" + cred.password, 'binary') + ":" + this._nonce + ":" + cnonce + ":" + cred.authzid);
            } else {
                ha1 = md5(md5(cred.username + ":" + realm + ":" + cred.password, 'binary') + ":" + this._nonce + ":" + cnonce);
            }

            if (qop == 'auth') {
                ha2 = md5('AUTHENTICATE:' + uri);
            } else if (qop == 'auth-int' || qop == 'auth-conf') {
                ha2 = md5('AUTHENTICATE:' + uri + ':00000000000000000000000000000000');
            }

            digest = md5(ha1 + ":" + this._nonce + ":" + nc + ":" + cnonce + ":" + qop + ":" + ha2);
            str += ',response=' + digest;

            if (this._charset == 'utf-8') {
                str += ',charset=utf-8';
            }
            if (cred.authzid) {
                str += 'authzid="' + cred.authzid + '"';
            }

            return str;
        };

        /**
         * Decode a challenge issued by the server.
         *
         * @param {String} chal
         * @return {Mechanism} for chaining
         * @api public
         */
        Mechanism.prototype.challenge = function (chal) {
            var dtives = parse(chal);

            // TODO: Implement support for multiple realm directives, as allowed by the
            //       DIGEST-MD5 specification.
            this._realm = dtives['realm'];
            this._nonce = dtives['nonce'];
            this._qop = (dtives['qop'] || 'auth').split(',');
            this._stale = dtives['stale'];
            this._maxbuf = parseInt(dtives['maxbuf']) || 65536;
            this._charset = dtives['charset'];
            this._algo = dtives['algorithm'];
            this._cipher = dtives['cipher'];
            if (this._cipher) {
                this._cipher.split(',');
            }
            return this;
        };

        /**
         * Parse challenge.
         *
         * @api private
         */
        function parse(chal) {
            var dtives = {};
            var tokens = chal.split(/,(?=(?:[^"]|"[^"]*")*$)/);
            for (var i = 0, len = tokens.length; i < len; i++) {
                var dtiv = /(\w+)=["]?([^"]+)["]?$/.exec(tokens[i]);
                if (dtiv) {
                    dtives[dtiv[1]] = dtiv[2];
                }
            }
            return dtives;
        }

        /**
         * Return a unique nonce with the given `len`.
         *
         *     genNonce(10)();
         *     // => "FDaS435D2z"
         *
         * @param {Number} len
         * @return {Function}
         * @api private
         */
        function genNonce(len) {
            var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
                charlen = chars.length;

            return function () {
                var buf = [];
                for (var i = 0; i < len; ++i) {
                    buf.push(chars[Math.random() * charlen | 0]);
                }
                return buf.join('');
            };
        }

        /**
         * Return md5 hash of the given string and optional encoding,
         * defaulting to hex.
         *
         *     md5('wahoo');
         *     // => "e493298061761236c96b02ea6aa8a2ad"
         *
         * @param {String} str
         * @param {String} encoding
         * @return {String}
         * @api private
         */
        function md5(str, encoding) {
            return new Md5().update(str).digest(encoding || 'hex');
        }

        return Mechanism;
    }();

    /* ./vk/static_src/assets/sasl.js }}} */

    /* {{{ ./vk/static_src/app/010_global.js */

    function noop() {}

    // clobbered by Henry
    var fn_tooltip = $ && $.fn && $.fn.tooltip || function () {};

    /* ./vk/static_src/app/010_global.js }}} */

    /* {{{ ./vk/static_src/app/020_date.js */

    function json_to_local_date(str) {
        if (str instanceof Date) {
            return str;
        }

        if (typeof str === 'number') {
            str = new Date(str).toISOString();
        }

        var e = /^0*(\d+)\D*0*(\d+)\D*0*(\d+)\D*0*(\d+)\D*0*(\d+)\D*0*(\d+)(\D*0*\d+)?/.exec(str);
        if (!e) {
            return str;
        }
        var _ = e[0],
            y = e[1],
            m = e[2],
            d = e[3],
            h = e[4],
            i = e[5],
            s = e[6],
            v = e[7];


        if (v && +v) {
            v = 1000 * +('0.' + v) | 0;
        } else {
            v = 0;
        }

        var result = new Date(+y, +m - 1, // Jan == 0, Dec == 11
        +d, 12, 0, +s, v);
        result.setHours(+h);
        result.setMinutes(+i - result.getTimezoneOffset());

        return result;
    }

    /* ./vk/static_src/app/020_date.js }}} */

    /* {{{ ./vk/static_src/app/020_format.js */

    function format_d(p, n) {
        if (n < 0) {
            return '-' + format_d(p, n);
        }

        n = String(n);
        return (p + n).slice(-Math.max(n.length, p.length));
    }

    function format_date(format, date) {
        date = json_to_local_date(date);

        return format.replace(/%[a-z]/ig, function (m) {
            switch (m[1]) {
                // https://secure.php.net/manual/en/function.date.php
                case 'd':
                    return format_d('00', date.getDate());
                case 'D':
                    return 'SoMoDiMiDoFrSa'.substr(date.getDay() * 2, 2);

                case 'm':
                    return format_d('00', date.getMonth());
                case 'M':
                    return 'JanFebMärAprMaiJunJulAugSepOktNovDez'.substr(date.getMonth() * 3, 3);

                case 'y':
                    return format_d('00', date.getFullYear() % 100);
                case 'Y':
                    return format_d('0000', date.getFullYear());

                case 'H':
                    return format_d('00', date.getHours());
                case 'i':
                    return format_d('00', date.getMinutes());
                case 's':
                    return format_d('00', date.getSeconds());
                case 'v':
                    return format_d('000', date.getMilliseconds());

                case '%':
                    return '%';
            }
            return m;
        });
    }

    /* ./vk/static_src/app/020_format.js }}} */

    /* {{{ ./vk/static_src/app/030_assets.js */

    var spinner_src = '<?xml version="1.0" encoding="utf-8"?><svg width="188px" height="188px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="uil-hourglass"><rect x="0" y="0" width="100" height="100" fill="none" class="bk"></rect><g><path fill="none" stroke="#003366" stroke-width="5" stroke-miterlimit="10" d="M58.4,51.7c-0.9-0.9-1.4-2-1.4-2.3s0.5-0.4,1.4-1.4 C70.8,43.8,79.8,30.5,80,15.5H70H30H20c0.2,15,9.2,28.1,21.6,32.3c0.9,0.9,1.4,1.2,1.4,1.5s-0.5,1.6-1.4,2.5 C29.2,56.1,20.2,69.5,20,85.5h10h40h10C79.8,69.5,70.8,55.9,58.4,51.7z" class="glass"></path><clipPath id="uil-hourglass-clip1"><rect x="15" y="20" width="70" height="25" class="clip"><animate attributeName="height" from="25" to="0" dur="1s" repeatCount="indefinite" values="25;0;0" keyTimes="0;0.5;1"></animate><animate attributeName="y" from="20" to="45" dur="1s" repeatCount="indefinite" values="20;45;45" keyTimes="0;0.5;1"></animate></rect></clipPath><clipPath id="uil-hourglass-clip2"><rect x="15" y="55" width="70" height="25" class="clip"><animate attributeName="height" from="0" to="25" dur="1s" repeatCount="indefinite" values="0;25;25" keyTimes="0;0.5;1"></animate><animate attributeName="y" from="80" to="55" dur="1s" repeatCount="indefinite" values="80;55;55" keyTimes="0;0.5;1"></animate></rect></clipPath><path d="M29,23c3.1,11.4,11.3,19.5,21,19.5S67.9,34.4,71,23H29z" clip-path="url(#uil-hourglass-clip1)" fill="#99CC00" class="sand"></path><path d="M71.6,78c-3-11.6-11.5-20-21.5-20s-18.5,8.4-21.5,20H71.6z" clip-path="url(#uil-hourglass-clip2)" fill="#99CC00" class="sand"></path><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="180 50 50" repeatCount="indefinite" dur="1s" values="0 50 50;0 50 50;180 50 50" keyTimes="0;0.7;1"></animateTransform></g></svg>';

    var svg_url_cache = {};

    function get_svg_url(src) {
        var result = svg_url_cache[src];
        if (!result) {
            svg_url_cache[src] = result = URL.createObjectURL(new Blob([src], { type: 'image/svg+xml' }));
            $(window).on('unload', function () {
                try {
                    URL.revokeObjectURL(result);
                } catch (ex) {
                    console.log('Supressed exception', ex);
                }
            });
        }
        return result;
    }

    /* ./vk/static_src/app/030_assets.js }}} */

    /* {{{ ./vk/static_src/app/050_dialog.js */

    function dialog(div_content, dialog_options) {
        var close = dialog_options.close || noop;
        dialog_options.close = function () {
            var d = result;
            result = null;
            if (!d) {
                return;
            }

            try {
                close.apply(this, arguments);
            } finally {
                try {
                    d.dialog('destroy');
                } finally {
                    d.remove();
                }
            }
        };

        if (dialog_options.closeOnEscape == null) {
            var open = dialog_options.open || noop;
            dialog_options.open = function () {
                $('>.ui-dialog-titlebar>.ui-dialog-titlebar-close', result.closest('.ui-dialog')).hide();
                open.apply(this, arguments);
            };
            dialog_options.closeOnEscape = false;
        }

        if (dialog_options.modal == null) {
            dialog_options.modal = true;
        }
        if (dialog_options.width == null) {
            dialog_options.width = 600;
        }
        if (dialog_options.height == null) {
            dialog_options.height = 350;
        }

        var result = $('<div/>', {
            append: div_content
        });
        result.dialog(dialog_options);

        ensure_dialog_front(result);

        return function () {
            if (result) {
                result.dialog('close');
            }
        };
    }

    function ensure_dialog_front(d) {
        setTimeout(function () {
            var dialog_wrapper = d.closest('.ui-dialog');
            dialog_wrapper.css('z-index', 101);
            if (dialog_wrapper.next().length) {
                dialog_wrapper.appendTo(document.body);
            }
        }, 4);
    }

    /* ./vk/static_src/app/050_dialog.js }}} */

    /* {{{ ./vk/static_src/app/050_linklist.js */

    var LinklistFns = function () {
        var parse = JSON.parse,
            stringify = JSON.stringify;


        function table_row(label, input) {
            var id = 'lltr' + (Math.random() + ~new Date());

            if (typeof label === 'string') {
                label = document.createTextNode(label);
            }
            label = $('<label/>', {
                attr: {
                    for: id
                },
                append: label
            });
            label = $('<div/>', {
                css: {
                    display: 'table-cell',
                    verticalAlign: 'middle',
                    padding: '0.3ex',
                    whiteSpace: 'nowrap'
                },
                append: label
            });

            input.attr({ id: id }).css({
                width: '100%',
                maxWidth: '100%'
            });
            input = $('<div/>', {
                css: {
                    display: 'table-cell',
                    verticalAlign: 'middle',
                    padding: '0.3ex',
                    width: '100%',
                    maxWidth: '100%'
                },
                append: input
            });

            return $('<div/>', {
                css: {
                    display: 'table-row',
                    width: '100%',
                    maxWidth: '100%'
                },
                append: [label, input]
            });
        }

        function text_input(val) {
            if (!val) {
                val = '';
            }
            return $('<input/>', {
                attr: {
                    type: 'text',
                    autocomplete: 'on'
                },
                val: val
            });
        }

        function LinklistFns(elem, list, box) {
            var self = this;
            self.elem = elem;
            self.list = list;
            self.box = box;
            self.value = null;
            self.ignore_update = 0;
            self.reinit();
        }

        function reinit(row_values) {
            var self = this;
            var list = self.list;


            if (row_values == null) {
                var row_values = parse(self.elem.val());
            }

            function new_row(title, destination, frame) {
                var title_input = text_input(title);
                var destination_input = text_input(destination);
                var frame_input = text_input(!frame ? '' : frame === true ? '1' : frame);

                var row = $('<li/>', {
                    append: $('<div/>', {
                        css: {
                            display: 'table',
                            border: '1px solid #aaa',
                            margin: '0.3ex',
                            background: '#f4f4f4'
                        },
                        append: [table_row('(Alternativ-)Titel u/o Beschreibung: ', title_input), table_row('Ziel (CMS-Pfad oder absolute Adresse): ', destination_input).css('margin', '0.3ex 0'), table_row(
                        // text is not a defined for HTML, but <span> cannot be used in here because it has a style assigned to it
                        $('<text/>', { append: [document.createTextNode('Neues Fenster  / Name des neuen Fensters '), $('<abbr/>', {
                                attr: {
                                    title: 'Einfach nur „1“ eingeben für ein unbenanntes neues Fenster! (Empfohlen) '
                                },
                                text: '[?]'
                            })[0], document.createTextNode(': ')] }), frame_input)]
                    }),
                    appendTo: list
                });

                return row;
            }

            function add_new_row_btn() {
                var btn = $('<li/>', {
                    append: [$('<label/>', {
                        append: $('<button/>', {
                            text: 'neue Zeile',
                            on: {
                                click: function (ev) {
                                    ev.preventDefault();
                                    btn.remove();
                                    new_row();
                                    add_new_row_btn();
                                }
                            }
                        })
                    }), document.createTextNode(' '), $('<abbr/>', {
                        attr: {
                            title: 'Einen Eintrag komplett leeren, um ihn (beim Speichern) zu löschen.'
                        },
                        text: '[?]'
                    })],
                    appendTo: list
                });
                return btn;
            }

            list.empty();
            [].forEach.call(row_values, function (_ref) {
                var title = _ref.title,
                    destination = _ref.destination,
                    frame = _ref.frame;
                return new_row(title, destination, frame);
            });
            add_new_row_btn();

            self.value = row_values;
        }

        function val(new_value) {
            var self = this;
            if (new_value == null) {
                return self.value;
            } else {
                self.elem.val(stringify(new_value));
                self.reinit(new_value);
                return self;
            }
        }

        function update() {
            debugger;

            var self = this;
            if (self.ignore_update) {
                return;
            }

            var new_value = [];
            [].forEach.call(self.list.find('>li'), function (li) {
                var _map$call = [].map.call($('input', li), function (e) {
                    return $(e).val().trim();
                }),
                    title = _map$call[0],
                    destination = _map$call[1],
                    frame = _map$call[2];

                if (!title && !destination && !frame) {
                    return;
                }
                if (!frame) {
                    frame = false;
                } else if (frame === '1') {
                    frame = true;
                }
                new_value.push({ title: title, destination: destination, frame: frame });
            });

            ++self.ignore_update;
            try {
                var new_value = stringify(new_value);
                self.elem.val(new_value);
            } finally {
                --self.ignore_update;
            }
        }

        var linklist_fns_proto = Object.create(null);
        linklist_fns_proto.reinit = reinit;
        linklist_fns_proto.val = val;
        linklist_fns_proto.update = update;
        LinklistFns.prototype = linklist_fns_proto;

        return LinklistFns;
    }();

    function make_linklist(selector) {
        var result = $();
        [].push.call(result, [].map.call($(selector), function (elem) {
            elem = $(elem);

            var box = $('<div/>', {
                css: {
                    margin: 0,
                    padding: 0,
                    border: 0,
                    display: 'inline-box'
                },
                on: {
                    change: function (ev) {
                        fns.update();

                        var _elem$data = elem.data(),
                            changed = _elem$data.changed;

                        if (changed) {
                            changed.prop('checked', true);
                        }
                    }
                },
                insertAfter: elem
            });

            $('<div/>', {
                css: {
                    display: 'none'
                },
                append: elem,
                appendTo: box
            });

            var list = $('<ol/>', {
                appendTo: box
            });

            var fns = new LinklistFns(elem, list, box);
            elem.data('linklist', fns);

            return box;
        }));
        return result;
    }

    /* ./vk/static_src/app/050_linklist.js }}} */

    /* {{{ ./vk/static_src/app/050_processing.js */

    function open_process_indicator(title) {
        var close_dialog = dialog($('<div/>', {
            css: {
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            append: $('<img/>', {
                css: {
                    display: 'block',
                    position: 'relative',
                    height: 188,
                    width: 188,
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                },
                src: get_svg_url(spinner_src)
            })
        }), { title: title });
        return function () {
            if (close_dialog) {
                setTimeout(close_dialog, 16);
                close_dialog = null;
            }
        };
    }

    /* ./vk/static_src/app/050_processing.js }}} */

    /* {{{ ./vk/static_src/app/050_websocket.js */

    function websocket(url, settings) {
        var expeced_close = 0;

        var ws = new WebSocket(url);

        function onunload() {
            var _ws = ws;
            ws = null;
            if (_ws && !expeced_close) {
                ++expeced_close;
                _ws.close();
            }
        }

        if (ws) {
            var close_process_indicator = open_process_indicator('Websocket wird geöffnet …');

            $(ws).on({
                open: function (ev) {
                    console.log('opened ws', this);
                    $(window).on('unload', onunload);
                    close_process_indicator();
                    if (ws && !expeced_close) {
                        (settings.open || noop).call(this, ev);
                    }
                },
                close: function (ev) {
                    var _ws = ws;
                    ws = null;
                    console.log('closed ws', this);
                    $(window).off('unload', onunload);
                    close_process_indicator();
                    if (_ws && !expeced_close) {
                        (settings.close || noop).call(this, ev);
                    }
                },
                error: function (ev) {
                    var _ws = ws;
                    ws = null;
                    console.log('errored ws', this);
                    $(window).off('unload', onunload);
                    close_process_indicator();
                    if (_ws && !expeced_close) {
                        (settings.error || noop).call(this, ev);
                    }
                },
                message: function (ev) {
                    var data = ev.originalEvent && ev.originalEvent.data || ev.data;
                    if (typeof data === 'string') {
                        try {
                            data = JSON.parse(data);
                        } catch (ex) {
                            console.log('Suppressed exception', ex);
                        }
                    }
                    console.log('<', data);

                    var _ref2 = data || {},
                        type = _ref2.type,
                        data = _ref2.data;

                    ((settings.callback || {})[type] || noop).call(ws, data);
                }
            });

            var _send = ws.send;
            ws.send = function (data) {
                console.log('>', data);
                try {
                    data = JSON.stringify(data);
                } catch (ex) {
                    console.log('Suppressed exception', ex);
                    data = JSON.stringify(String(data));
                }
                return _send.call(this, data);
            };
        } else {
            setTimeout(function () {
                (settings.error || noop).call(null, null);
            }, 4);
        }

        return ws;
    }

    /* ./vk/static_src/app/050_websocket.js }}} */

    /* {{{ ./vk/static_src/app/070_cms.js */

    function init_cms(url_ws, login_ws) {
        var form = $('#form');
        var nonce;
        var id = (/.*[/](\d+)[/.]/.exec(location.pathname) || [])[1] || 0;
        var close_process_indicator;
        var login_progress;
        var actual_nonce;
        var prevent_changed_tick = 0;
        var current_path;
        var changes;
        var _tooltip_cms_path;
        var template_prefix;

        function input_set(input, value) {
            var _input$data = input.data(),
                presentation = _input$data.presentation,
                changed = _input$data.changed;

            (({
                html: function () {
                    input.jqteVal(value);
                },
                linklist: function () {
                    input.data('linklist').val(value);
                }
            })[presentation] || function () {
                input.val(value);
            })();
            changed.prop('checked', false);
        }

        function input_get(input) {
            var _input$data2 = input.data(),
                presentation = _input$data2.presentation,
                changed = _input$data2.changed;

            var value = ({
                // void
            }[presentation] || function () {
                return input.val();
            })();
            var changed = changed.prop('checked');
            return { value: value, changed: changed };
        }

        function do_reset(ev) {
            ev.preventDefault();

            do_close_process_indicator();
            login_progress = $('<ol/>');
            close_process_indicator = dialog($('<div/>', { append: login_progress }), { title: 'Dokument wird zurückgesetzt …' });
            login_add_li(document.createTextNode('Lese aktuellen Namen aus …'));

            ws.send({
                type: 'path',
                data: 0
            });
        }

        function do_submit(ev) {
            ev.preventDefault();

            do_close_process_indicator();
            login_progress = $();
            close_process_indicator = open_process_indicator('Speichere geänderte Daten  …');

            var values = {};
            [].forEach.call(form.find('[data-presentation]'), function (e) {
                var e = $(e);
                values[e.attr('name')] = input_get(e);
            });

            ws.send({
                type: 'set',
                data: {
                    nonce: actual_nonce,
                    values: values
                }
            });
        }

        function show_rename_dialog() {
            var new_name_input = $('<input/>', {
                attr: {
                    autocomplete: 'off',
                    type: 'text'
                },
                val: /[/]([^/]+)$/.exec(current_path)[1]
            });

            function do_submit() {
                var new_name = new_name_input.val().trim();
                if (!new_name) {
                    close();
                    return;
                }

                if (/[^0-9A-Z_]/i.exec(name)) {
                    alert('Der Name darf nur alphanummerische Zeichen und Unterstriche enthalten');
                    new_name_input[0].focus();
                    return;
                }

                close_process_indicator = open_process_indicator('Benenne Datei um …');
                close();

                ws.send({
                    type: 'rename',
                    data: {
                        nonce: actual_nonce,
                        name: new_name
                    }
                });
            }

            var close = dialog($('<form/>', {
                attr: {
                    action: 'javascript:;'
                },
                append: $('<label/>', {
                    text: 'Neuer Name: ',
                    append: new_name_input
                }),
                on: {
                    submit: function (ev) {
                        ev.preventDefault();
                        do_submit();
                    },
                    reset: function (ev) {
                        ev.preventDefault();
                        close();
                    }
                }
            }), {
                title: 'Umbenennen',
                buttons: {
                    umbenennen: do_submit,
                    abbrechen: function () {
                        close();
                    }
                }
            });
        }

        function show_move_dialog() {
            var new_name_input = $('<textarea/>', {
                attr: {
                    autocomplete: 'off'
                },
                css: {
                    width: '100%',
                    maxWidth: '100%'
                },
                val: /^([/].*)[/][^/]+$/.exec(current_path)[1]
            });

            function do_submit() {
                var new_name = new_name_input.val().trim();
                if (!new_name) {
                    close();
                    return;
                }

                var new_name = /^(?:[/]?ROOTPUB)?\s*\/?((?:\s*[A-Z0-9_]+\s*(?:\/|$))+)/i.exec(new_name);
                if (!new_name) {
                    alert('Der angegebene Pfad ist ungültig.');
                    new_name_input[0].focus();
                    return;
                }

                close_process_indicator = open_process_indicator('Verschiebe Datei …');
                close();

                ws.send({
                    type: 'move',
                    data: {
                        nonce: actual_nonce,
                        path: new_name[1]
                    }
                });
            }

            var close = dialog($('<form/>', {
                attr: {
                    action: 'javascript:;'
                },
                append: $('<label/>', {
                    css: {
                        width: '100%',
                        maxWidth: '100%'
                    },
                    text: 'Neuer Pfad: ',
                    append: [document.createElement('br'), new_name_input[0]]
                }),
                on: {
                    submit: function (ev) {
                        ev.preventDefault();
                        do_submit();
                    },
                    reset: function (ev) {
                        ev.preventDefault();
                        close();
                    }
                }
            }), {
                title: 'Verschieben',
                buttons: {
                    verschieben: do_submit,
                    abbrechen: function () {
                        close();
                    }
                }
            });
        }

        var input_username = $('<input/>', {
            type: 'text',
            name: 'username'
        });
        var input_password = $('<input/>', {
            type: 'password',
            name: 'password'
        });
        var input_path = $('<textarea/>', {
            name: 'path',
            val: 'ROOTPUB / vetmed / einrichtungen / zentrale / _bibliothek_neu / aktuelles',
            css: {
                width: '100%',
                height: '3em'
            }
        });
        var input_form = $('<form/>', {
            attr: {
                autocomplete: 'on',
                action: 'javascript:;'
            },
            on: {
                submit: function (ev) {
                    ev.preventDefault();
                    do_login();
                }
            },
            append: [$('<div/>').text('Bitte geben Sie Ihre Anmeldedaten für das CMS ein.'), $('<div/>', {
                append: $('<label/>', {
                    text: 'Benutzername: ',
                    append: input_username
                })
            }), $('<div/>', {
                append: $('<label/>', {
                    text: 'Passwort: ',
                    append: input_password
                })
            }), $('<div/>', {
                append: $('<label/>', {
                    text: 'Pfad dest Termin-Ordners: ',
                    append: input_path
                })
            })]
        });

        function do_close_process_indicator() {
            try {
                var close = close_process_indicator || noop;
                close_process_indicator = null;
                close();
            } catch (ex) {
                console.log('Supressed exception', ex);
            }
        }

        function do_login() {
            do_close_process_indicator();

            login_progress = $('<ol/>');
            close_process_indicator = dialog($('<div/>', {
                append: login_progress
            }), {
                title: 'Anmeldung wird durchgeführt …'
            });
            login_add_li(document.createTextNode('Anmeldedaten werden übersandt …'));

            ws.send({
                type: 'login',
                data: {
                    id: id,
                    'name': input_username.val(),
                    'password': input_password.val(),
                    'path': input_path.val()
                }
            });
        }

        function show_login_dialog() {
            var close_dialog = dialog(input_form, {
                title: 'Anmeldung im CMS',
                buttons: {
                    anmelden: function () {
                        close_dialog();
                        do_login();
                    }
                }
            });
        }

        function login_add_li() {
            var li = $('<li/>', {
                append: arguments,
                appendTo: login_progress
            });
            li[0].focus();
            return li;
        }

        function show_path(_ref3) {
            var id = _ref3.id,
                path = _ref3.path,
                preview = _ref3.preview;

            current_path = path;
            $('#cms-id').val(id);
            $('#cms-path').attr('href', preview).text(path);
        }

        function on_path(data) {
            var success = data.success,
                reason = data.reason,
                nonce = data.nonce;

            if (nonce) {
                actual_nonce = nonce;
            }

            if (!success) {
                alert(reason);
                setTimeout(function () {
                    close_process_indicator();
                }, 4);
                return;
            }

            show_path(data);

            login_add_li(document.createTextNode('Lese vorhandene Daten aus …'));
            ws.send({
                type: 'get',
                data: 0
            });
        }

        function on_login(data) {
            var success = data.success,
                reason = data.reason,
                next = data.next,
                template_html = data.template_html,
                template_name = data.template_name;


            if (nonce) {
                actual_nonce = nonce;
            }

            if (!success) {
                alert(reason);
                setTimeout(function () {
                    show_login_dialog();
                }, 4);
            } else if (success === true) {
                on_path(data);
            } else {
                if (template_name) {
                    template_prefix = template_name;
                }
                if (template_html) {
                    form.html(template_html);
                    init_form();
                }

                var text = {
                    login: 'Anmeldung ins CMS …',

                    id: 'Traversiere zu existierendem Eintrag …',
                    template: 'Erfrage verwendete Vorlage …',
                    inspector: 'Öffne existierenden Eintrag …',

                    path: 'Gehe zu angegebenem Ordner …',
                    tmp: 'Erstelle temporäres Dokument …',
                    doc: 'Rufe erstelltes Dokument auf'
                }[next] || next;
                login_add_li(document.createTextNode(text));
            }
        }

        function on_set(_ref4) {
            var success = _ref4.success,
                reason = _ref4.reason,
                nonce = _ref4.nonce;

            if (nonce) {
                actual_nonce = nonce;
            }

            if (!success) {
                alert(reason);
                close_process_indicator();
                return;
            }

            if (success === true) {
                close_process_indicator();
                changes.prop('checked', false);
            }
        }

        function on_get(_ref5) {
            var success = _ref5.success,
                reason = _ref5.reason,
                forms = _ref5.forms,
                nonce = _ref5.nonce;

            if (nonce) {
                actual_nonce = nonce;
            }

            if (!success) {
                alert(reason);
                add_close_btn('OK.');
                return;
            }

            Object.keys(forms || {}).forEach(function (form) {
                var section = $('thead [data-form="' + form + '"]');
                login_add_li(document.createTextNode('Abschnitt „' + section.text() + '“ erhalten.'));

                ++prevent_changed_tick;
                var values = forms[form];
                Object.keys(values).forEach(function (name) {
                    var input = $('[name="' + template_prefix + '-' + form + '-' + name + '"]');
                    var value = values[name];
                    input_set(input, value);
                });
                --prevent_changed_tick;
            });

            if (success === true) {
                add_close_btn('OK.');
            }
        }

        function on_rename(data) {
            var success = data.success,
                reason = data.reason,
                nonce = data.nonce;

            if (nonce) {
                actual_nonce = nonce;
            }

            if (!success) {
                alert(reason);
                return;
            }

            show_path(data);
            do_close_process_indicator();
        }

        function on_move(data) {
            var success = data.success,
                reason = data.reason,
                nonce = data.nonce;

            if (nonce) {
                actual_nonce = nonce;
            }

            if (!success) {
                alert(reason);
                return;
            }

            show_path(data);
            do_close_process_indicator();
        }

        function add_close_btn(text) {
            var btn = $('<button/>', {
                text: 'OK.',
                on: {
                    click: function (ev) {
                        ev.preventDefault();
                        do_close_process_indicator();
                    }
                }
            })[0];
            login_add_li(btn);
            setTimeout(function () {
                btn.focus();
            }, 4);
        }

        function init_form() {
            debugger;

            form.on('click change', 'abbr>input', function (ev) {
                ev.preventDefault();
            });

            form.on('change', '[data-presentation=""]', function (ev) {
                var e = $(this);

                var _e$data = e.data(),
                    changed = _e$data.changed;

                changed.prop('checked', true);
            });

            form.find('button[type=submit]').on('click', do_submit);
            form.find('button[type=reset]').on('click', do_reset);

            changes = $();
            [].push.apply(changes, [].map.call(form.find('[data-presentation]'), function (user_input) {
                var user_input = $(user_input);
                var changed_input = user_input.closest('tr').find('abbr>input');
                user_input.data('changed', changed_input);
                return changed_input[0];
            }));

            [].forEach.call(form.find('[data-presentation]'), function (input) {
                var input = $(input);

                var _input$data3 = input.data(),
                    presentation = _input$data3.presentation,
                    changed = _input$data3.changed;

                (({
                    html: function () {
                        td = input.closest('td').css('padding', 0);
                        var scapegoat_div = $('<div/>', {
                            css: {
                                width: '100px'
                            },
                            appendTo: td,
                            append: input
                        });
                        input.jqte({
                            color: false,
                            fsize: false,
                            placeholder: 'Formatierter Hauptinhalt.',
                            change: function () {
                                if (!prevent_changed_tick) {
                                    changed.prop('checked', true);
                                }
                            }
                        });
                        td.append(input.closest('.jqte'));
                        scapegoat_div.remove();

                        ++prevent_changed_tick;
                        input.jqteVal('-');
                        input.jqteVal('');
                        --prevent_changed_tick;
                    },
                    linklist: function () {
                        td = input.closest('td').css('padding', 0);
                        make_linklist(input);
                    },
                    datetime: function () {
                        var old_val;
                        input.attr({
                            autocomplete: 'off'
                        }).on({
                            change: function (ev) {
                                var new_val = input.val();
                                if (old_val === new_val) {
                                    ev.stopPropagation();
                                }
                            }
                        }).datetimepicker({
                            lang: 'de',
                            weeks: true,
                            todayButton: true,
                            defaultSelect: true,
                            dayOfWeekStart: 1,
                            onShow: function () {
                                old_val = input.val();
                            },

                            format: 'd.m.Y H:i',
                            timepicker: true,
                            step: 15
                        });
                    }
                })[presentation] || noop)();
            });

            fn_tooltip.call($('#cms-path'), {
                items: '*',
                show: null,
                content: function (callback) {
                    var self = $(this);

                    function li(text, href, onclick) {
                        return $('<li/>', {
                            css: {
                                listStyleType: 'none',
                                paddingLeft: 0
                            },
                            append: $('<a/>', {
                                text: text,
                                attr: {
                                    href: href,
                                    target: '_blank'
                                },
                                css: {
                                    color: '#06c'
                                },
                                on: {
                                    click: function () {
                                        setTimeout(function () {
                                            var tooltip_cms_path = _tooltip_cms_path;
                                            _tooltip_cms_path = null;
                                            if (tooltip_cms_path) {
                                                tooltip_cms_path.remove();
                                            }
                                        }, 4);
                                        (onclick || noop).apply(this, arguments);
                                    }
                                }
                            })
                        });
                    }

                    var href = self.attr('href');
                    setTimeout(callback, 4, $('<div/>', {
                        append: $('<ul/>', {
                            css: {
                                whiteSpace: 'nowrap',
                                padding: 0
                            },
                            append: [li('Vorschau im CMS', href), li('Bearbeiten im CMS', href.replace(/\/pb(?=\W|$)/, '/cb')), li('Umbenennen', 'javascript:;', function (ev) {
                                ev.preventDefault();
                                show_rename_dialog();
                            }), li('Verschieben', 'javascript:;', function (ev) {
                                ev.preventDefault();
                                show_move_dialog();
                            })]
                        })
                    }));
                },
                open: function (ev, _ref6) {
                    var tooltip = _ref6.tooltip;

                    _tooltip_cms_path = tooltip;
                    tooltip.css({
                        width: 'inherit',
                        maxWidth: 'inherit'
                    });
                },
                close: function (ev, ui) {
                    ui.tooltip.hover(function () {
                        $(this).stop(true).fadeTo(400, 1);
                    }, function () {
                        $(this).fadeOut(400, function () {
                            $(this).remove();
                            _tooltip_cms_path = null;
                        });
                    });
                },

                position: {
                    my: 'top+2.5',
                    at: 'bottom',
                    collision: 'flipfit'
                }
            });

            $('#cms-path').on({
                click: function (ev) {
                    ev.preventDefault();
                    var self = $(this);
                    fn_tooltip.call(self, 'close');
                    fn_tooltip.call(self, 'open');
                }
            });
        }

        var ws = websocket(url_ws, {
            open: function () {
                show_login_dialog();
            },
            error: function (ev) {
                alert('Es konnte keine Verbindung zum Server hergestellt werden.\n' + 'Vermutlich müssen Sie diese Seite neu laden, damit Sie sie wieder verwenden können.');
            },

            callback: {
                login: on_login,
                get: on_get,
                set: on_set,
                path: on_path,
                rename: on_rename,
                move: on_move
            }
        });
    }

    /* ./vk/static_src/app/070_cms.js }}} */

    /* {{{ ./vk/static_src/app/070_create.js */

    function init_create(url_ws, login_ws) {
        var form = $('#form');

        function inputs(names) {
            var array = [];
            names.split(/\s/g).forEach(function (name) {
                var input = $("#" + name, form);
                array[name] = input;
                array.push(input);
            });
            return array;
        }

        var input_mandatory = inputs('titel art datum ort ansprechpartner');
        var input_optional = inputs('ende anmeldefrist veranstalter kosten anerkennung link freitext intern');
        var input_user = inputs('sAMAccountName name mail telephoneNumber');
        var input_btns = inputs('form_login form_submit');

        form.on({
            submit: function (ev) {
                ev.preventDefault();
            }
        });

        function click_login(ev, allow_logoff) {
            ev.preventDefault();
            do_login(allow_logoff, login_ws, function (attributes, start) {
                if (attributes) {
                    var sAMAccountName = attributes.sAMAccountName,
                        mail = attributes.mail,
                        givenName = attributes.givenName,
                        sn = attributes.sn,
                        telephoneNumber = attributes.telephoneNumber,
                        displayName = attributes.displayName;

                    if (input_user.name.prop('readonly')) {
                        input_user.name.val(displayName || (givenName ? sn + ", " + givenName : sn)).prop({ readonly: false });
                    }
                    if (input_user.mail.prop('readonly')) {
                        input_user.mail.val(mail).prop({ readonly: false });
                    }
                    if (input_user.telephoneNumber.prop('readonly')) {
                        input_user.telephoneNumber.val(telephoneNumber).prop({ readonly: false });
                    }
                    input_user.sAMAccountName.val(sAMAccountName);

                    input_btns.form_login.closest('tr').hide();
                    app_login_name.show().find('a').text(sAMAccountName).attr({
                        href: 'mailto:' + mail
                    });
                    app_login_link.text('abmelden');
                    $('.app-show-when-login').show();
                } else {
                    input_btns.form_login.closest('tr').show();
                    app_login_name.hide();
                    app_login_link.text('anmelden');
                    $('.app-show-when-login').hide();

                    input_user.name.val('').prop({ readonly: true });
                    input_user.mail.val('').prop({ readonly: true });
                    input_user.telephoneNumber.val('').prop({ readonly: true });
                    input_user.sAMAccountName.val('');
                }
            }, function (reason) {
                if (reason) {
                    alert('Es trat ein Fehler bei der Anmeldung auf:\n' + (reason.reason || reason));
                } else {
                    alert('Es trat ein unbekannter Fehler bei Ihrer Anmeldung auf.');
                }
            });
        }

        app_login_link_handler = function (ev) {
            click_login(ev, true);
        };

        input_btns.form_login.on({
            click: function (ev) {
                click_login(ev, false);
            }
        });

        input_btns.form_submit.on({
            click: function (ev) {
                ev.preventDefault();

                var mandatory = {};
                var optional = {};
                var vals = { mandatory: mandatory, optional: optional };
                var mandatory_absent;
                if (input_user.concat(input_mandatory).every(function (i) {
                    var val = i.val().trim();
                    if (/\S/.exec(val)) {
                        mandatory[i.attr('id')] = val;
                        return true;
                    }
                    mandatory_absent = i;
                })) {
                    input_optional.forEach(function (i) {
                        var val = i.val().trim();
                        if (/\S/.exec(val)) {
                            optional[i.attr('id')] = val;
                        }
                    });
                }

                if (!mandatory.sAMAccountName) {
                    input_btns.form_login.click();
                    alert('Sie müssen sich anmelden, bevor Sie die Veranstaltungsmeldung absenden können.');
                    return;
                }
                delete mandatory.sAMAccountName;

                if (mandatory_absent) {
                    mandatory_absent.closest('tr')[0].scrollIntoView();
                    mandatory_absent[0].focus();
                    alert('Sie müssen alle Pflichtfelder ausfüllen, bevor Sie die Veranstaltungsmeldung absenden können.');
                    return;
                }

                var ws = websocket(url_ws, {
                    error: function (ev) {
                        alert('Es konnte keine Verbindung zum Server hergestellt werden.\n' + 'Vermutlich müssen Sie diese Seite neu laden, damit Sie sie wieder verwenden können.');
                    },

                    callback: {
                        login: function () {
                            alert('Sie wurden zwischenzeitig abgemeldet und müssen sich erst wieder anmelden, ehe Sie die Veranstaltung anmelden können.');
                        },
                        nonce: function (nonce) {
                            vals.nonce = nonce;
                            ws.send(vals);
                        },
                        missing: function (items) {
                            alert('Der Server meldet, dass nicht alle nötigen Felder ausfüllt sind. Es fehlen: ' + JSON.stringify(items));
                        },
                        error: function (reason) {
                            alert(reason);
                        },
                        success: function (_ref7) {
                            var next = _ref7.next;

                            location.href = next;
                        }
                    }
                });
            }
        });
    }

    /* ./vk/static_src/app/070_create.js }}} */

    /* {{{ ./vk/static_src/app/070_edit.js */

    function init_edit(url_ws) {
        var form = $('#form');
        var nonce;
        var id = (/.*[/](\d+)[/.]/.exec(location.pathname) || [])[1] || 0;
        var inputs = [].map.call($('input,textarea', form), function (i) {
            return $(i);
        });
        var close_process_indicator;
        var cms_btn = $('#cms').closest('td').find('a');
        var next_callback;
        var ignore_changes = 0;

        function set_kv(key, value) {
            $('#' + key, form).val(value || '');
        }

        function set_kvs(kvs) {
            Object.keys(kvs || {}).forEach(function (key) {
                var value = kvs[key];
                if (/^(?:created|modified)$/.exec(key)) {
                    value = format_date('%D, %d. %M. %Y %H:%i:%s', value);
                }
                set_kv(key, value);
            });
        }

        function format_data(_ref8) {
            var _nonce = _ref8.nonce,
                announcement = _ref8.announcement,
                user = _ref8.user,
                fields = _ref8.fields;

            if (close_process_indicator) {
                close_process_indicator();
                close_process_indicator = null;
            }

            nonce = _nonce;

            var _ref9 = user || {},
                sAMAccountName = _ref9.sAMAccountName,
                displayName = _ref9.displayName;

            inputs.forEach(function (i) {
                i.data('changed', false);
                i.val('');
            });

            set_kvs(announcement);
            set_kvs(fields);
            set_kvs(user);

            var _next_callback = next_callback;
            next_callback = null;
            if (_next_callback) {
                _next_callback();
            }
        }

        function save() {
            if (!close_process_indicator) {
                close_process_indicator = open_process_indicator('Änderungen werden gespeichert …');
            }

            var fields = [];
            inputs.forEach(function (i) {
                if (i.data('changed') === true) {
                    var datum = { name: i.attr('id') };
                    var value = i.val();
                    if (value) {
                        datum.value = value;
                    }
                    fields.push(datum);
                }
            });

            ws.send({
                type: 'change',
                data: { nonce: nonce, fields: fields }
            });
        }

        function select() {
            ws.send({
                type: 'select',
                data: id
            });
        }

        $('#form_submit', form).on({
            click: function (ev) {
                ev.preventDefault();
                save();
            }
        });

        form.on('change keypress paste cut', 'input,textarea', function () {
            var self = $(this);
            self.data('changed', true);
        });

        cms_btn.on('click', function (ev) {
            if (ignore_changes || inputs.every(function (i) {
                return i.data('changed') !== true;
            })) {
                return;
            }

            ev.preventDefault();
            var close_dialog = dialog($('<p/>', {
                text: 'Sie müssen Ihre Änderungen zuerst speichern, bevor Sie sie ins CMS eintragen können.'
            }), {
                title: 'Ungespeicherte Änderungen',
                width: 500,
                height: 400,
                buttons: {
                    'speichern': function () {
                        close_dialog();
                        next_callback = function () {
                            cms_btn[0].click();
                        };
                        save();
                    },
                    'verwerfen': function () {
                        ++ignore_changes;
                        cms_btn[0].click();
                    },
                    'abbrechen': function () {
                        close_dialog();
                    }
                }
            });
        });

        var ws = websocket(url_ws, {
            open: function () {
                select();
            },
            error: function (ev) {
                alert('Es konnte keine Verbindung zum Server hergestellt werden.\n' + 'Vermutlich müssen Sie diese Seite neu laden, damit Sie sie wieder verwenden können.');
            },

            callback: {
                select: function (data) {
                    if (!data) {
                        alert('Die Ankündigung #' + id + ' wurde zwischenzeitig gelöscht oder die Nummer ist ungültig.');
                    } else {
                        format_data(data);
                    }
                },
                changed: function (data) {
                    if (!data) {
                        alert('Bei der Speicherung Ihrer Änderung ist ein Datenbankfehler aufgetreten.');
                    } else {
                        format_data(data);
                    }
                },
                cms: function (data) {
                    var state = data.state,
                        next = data.next;

                    if (state) {
                        format_data(data);
                        cms_btn.click();
                    } else {
                        location.href = next;
                    }
                }
            }
        });
    }

    /* ./vk/static_src/app/070_edit.js }}} */

    /* {{{ ./vk/static_src/app/070_login.js */

    var login_form_triple;

    function do_login(allow_logoff, login_ws, success_callback, error_callback) {
        var server_challenge = void 0;
        var close_dialog = void 0;
        var ws = void 0;

        if (!login_form_triple) {
            var input_name = $('<input/>', {
                attr: {
                    type: 'text'
                },
                css: {
                    textTransform: 'lowercase'
                }
            });

            var input_pw = $('<input/>', {
                attr: { type: 'password' }
            });

            var form = $('<form/>', {
                attr: {
                    action: 'javascript:;'
                },
                append: [$('<div/>', {
                    attr: {
                        class: 'ui-icon ui-icon-key'
                    },
                    css: {
                        float: 'left',
                        margin: '25px 20px 8em 10px'
                    }
                }), $('<p/>', {
                    append: [document.createTextNode('Bitte geben Sie Ihren Accountnamen und Ihr Passwort ein. '), document.createTextNode('Der Accountname sollte hierbei komplett klein geschrieben sein nicht nicht mit '), $('<tt/>', { text: 'FU-BERLIN\\' }), document.createTextNode(' beginnen.')]
                }), $('<p/>', {
                    append: $('<label/>', {
                        text: 'Accountname: ',
                        append: input_name
                    })
                }), $('<p/>', {
                    append: $('<label/>', {
                        text: 'Passwort: ',
                        append: input_pw
                    })
                })],
                on: {
                    submit: function (ev) {
                        ev.preventDefault();
                        do_reply();
                    },
                    reset: function (ev) {
                        ev.preventDefault();
                        close_dialog();
                    }
                }
            });

            login_form_triple = [input_name, input_pw, form];
        } else {
            var _login_form_triple = login_form_triple,
                input_name = _login_form_triple[0],
                input_pw = _login_form_triple[1],
                form = _login_form_triple[2];
        }

        function do_reply() {
            close_dialog();

            var name = input_name.val();
            var lk_name = name.toLowerCase();
            if (name !== lk_name) {
                input_name.val(lk_name);
                name = lk_name;
            }

            ws.send({
                name: 'FU-BERLIN\\' + name,
                response: input_pw.val()
                /*
                            response: (new Sasl).challenge(server_challenge).response({
                                username: name,
                                password: input_pw.val(),
                                host: 'windc1.fu-berlin.de',
                                serviceType: 'ldap'
                            }),
                */
            });
        }

        ws = websocket(login_ws, {
            error: function (ev) {
                error_callback('Es konnte keine Verbindung zum Server hergestellt werden.');
            },

            callback: {
                fatal: function (reason) {
                    error_callback(reason);
                },
                challenge: function (data) {
                    server_challenge = data;

                    try {
                        (close_dialog || noop)();
                    } catch (ex) {
                        console.log('Supressed exception', ex);
                    }

                    close_dialog = dialog(form, {
                        title: 'Anmelden',
                        buttons: {
                            anmelden: function () {
                                do_reply();
                            },
                            abbrechen: function () {
                                close_dialog();
                            }
                        }
                    });
                },
                success: function (_ref10) {
                    var login = _ref10.login,
                        payload = _ref10.payload,
                        attributes = _ref10.attributes,
                        start = _ref10.start;

                    console.log({ server_challenge: server_challenge, allow_logoff: allow_logoff });
                    if (!server_challenge && !allow_logoff) {
                        // already logged but not supposed to logoff
                        success_callback(attributes, start);
                    } else {
                        // logging in or logging off

                        var close_process_indicator = open_process_indicator('Übertrage Anmeldedaten …');
                        $.ajax(login, {
                            data: payload,
                            contentType: 'text/plain',
                            method: 'POST',
                            dataType: 'json',
                            cache: false,
                            complete: function (xhr, status) {
                                close_process_indicator();
                                if (status !== 'success') {
                                    error_callback();
                                } else {
                                    var _ref11 = xhr.responseJSON || {},
                                        success = _ref11.success,
                                        reason = _ref11.reason;

                                    if (!success) {
                                        error_callback(reason);
                                    } else if (server_challenge) {
                                        success_callback(attributes, start);
                                    } else {
                                        success_callback(null, start);
                                    }
                                }
                            }
                        });
                    }
                }
            }
        });
    }

    function init_login(url_ws, login_ws) {
        console.log({ url_ws: url_ws });
        do_login(url_ws === '', login_ws, function (attributes, start) {
            location.href = start;
        }, function (reason) {
            if (reason) {
                alert('Es trat ein Fehler bei der Anmeldung auf:\n' + (reason.reason || reason));
            } else {
                alert('Es trat ein unbekannter Fehler bei Ihrer Anmeldung auf.');
            }
            setTimeout(function () {
                location.reload();
            }, 4);
        });
    }

    /* ./vk/static_src/app/070_login.js }}} */

    /* {{{ ./vk/static_src/app/070_users.js */

    function init_users(url_ws, login_ws) {
        var form = $('#form');
        var nonce;
        var close_process_indicator;

        var user_container = form.find('ul');
        var user_template = user_container.find('li').detach();

        var new_user_field = $('#form tbody:first');
        var new_user_inputs = new_user_field.find('input');
        new_user_field.find('button').on('click', function (ev) {
            ev.preventDefault();

            var data = { nonce: nonce };
            [].forEach.call(new_user_inputs, function (input) {
                input = $(input);
                data[input.attr('id')] = input.val();
            });

            do_close_process_indicator();
            close_process_indicator = open_process_indicator('Lege Konto an …');
            ws.send({
                type: 'add',
                data: data
            });
        });

        var user_lines = {};

        function do_close_process_indicator() {
            try {
                var close = close_process_indicator || noop;
                close_process_indicator = null;
                close();
            } catch (ex) {
                console.log('Supressed exception', ex);
            }
        }

        function do_list() {
            do_close_process_indicator();
            close_process_indicator = open_process_indicator('Lese Konten aus …');

            ws.send({
                type: 'list',
                data: 0
            });
        }

        function format_users(users) {
            [].forEach.call(Object.keys(users), function (sAMAccountName) {
                var user_data = users[sAMAccountName];

                var _ref12 = user_data || {},
                    id = _ref12.id,
                    email = _ref12.email,
                    displayName = _ref12.displayName,
                    granted = _ref12.granted;

                var user_line = user_lines[sAMAccountName];
                if (!id) {
                    delete user_lines[sAMAccountName];
                    if (user_line) {
                        user_line.remove();
                    }
                    return;
                }

                function btn_fun(btn, type, text, data_edit) {
                    function click(ev) {
                        ev.preventDefault();
                        debugger;

                        var id = user_line.data('id');
                        var data = { nonce: nonce, sAMAccountName: sAMAccountName, id: id };
                        data_edit(data);

                        do_close_process_indicator();
                        close_process_indicator = open_process_indicator(text);

                        ws.send({ type: type, data: data });
                    }
                    $(btn).on('click', click);
                }

                var inputs;
                if (!user_line) {
                    user_line = user_template.clone(true);
                    user_lines[sAMAccountName] = user_line;

                    inputs = {};

                    [].forEach.call(user_line.find('[id]'), function (input) {
                        input = $(input);
                        var id = input.attr('id');
                        inputs[id] = input;

                        user_line.find('[for="' + id + '"]').add(input).attr({
                            id: 'input' + (Math.random() + ~new Date())
                        });
                    });

                    inputs['granted'] = user_line.find('[name]').attr({
                        name: 'input' + (Math.random() + ~new Date())
                    });

                    var _user_line$find = user_line.find('button'),
                        btn_save = _user_line$find[0],
                        btn_delete = _user_line$find[1],
                        btn_grant_yes = _user_line$find[2],
                        btn_grant_no = _user_line$find[3];

                    btn_fun(btn_save, 'edit', 'Bearbeite Konto …', function (data) {
                        data.email = inputs['email'].val();
                        data.displayName = inputs['displayName'].val();
                    });
                    btn_fun(btn_delete, 'remove', 'Lösche Konto …', function (data) {
                        if (window.confirm('Wollen die das Konto mit dem Namen ' + data.sAMAccountName + ' wirklich löschen?') !== true) {
                            throw Error('aborted by user');
                        }
                    });
                    btn_fun(btn_grant_yes, 'grant', 'Gebe Konto frei …', function (data) {
                        data.grant = true;
                    });
                    btn_fun(btn_grant_no, 'grant', 'Sperre Konto …', function (data) {
                        data.grant = false;
                    });

                    user_line.data({ inputs: inputs }).appendTo(user_container);
                } else {
                    inputs = user_line.data('inputs');
                }

                inputs['sAMAccountName'].val(sAMAccountName);
                inputs['email'].val(email);
                inputs['displayName'].val(displayName);
                inputs['granted'].filter('[value="' + (granted ? '1' : '') + '"]').prop('checked', true);
                user_line.data('id', id);
            });
        }

        function edit_callback(_ref13) {
            var success = _ref13.success,
                reason = _ref13.reason,
                users = _ref13.users,
                _nonce = _ref13.nonce;

            if (_nonce) {
                nonce = _nonce;
            }

            if (!success) {
                if (reason) {
                    alert(reason);
                }
                do_close_process_indicator();
                return;
            }

            try {
                if (users) {
                    format_users(users);
                }
            } finally {
                if (success === true) {
                    do_close_process_indicator();
                }
            }
        }

        var ws = websocket(url_ws, {
            open: function () {
                do_list();
            },
            error: function (ev) {
                alert('Es konnte keine Verbindung zum Server hergestellt werden.\n' + 'Vermutlich müssen Sie diese Seite neu laden, damit Sie sie wieder verwenden können.');
            },

            callback: {
                list: edit_callback,
                add: edit_callback,
                remove: edit_callback,
                grant: edit_callback,
                edit: edit_callback
            }
        });
    }

    /* ./vk/static_src/app/070_users.js }}} */

    /* {{{ ./vk/static_src/app/090_init.js */

    var app_login_link_handler;
    var app_login_link = $('#app-login-link');
    var app_login_name = $('#app-login-name');

    setTimeout(function () {
        $('.main-nav-container').css({ zIndex: 20 });

        var _ref14 = $('body').data() || {},
            url_ws = _ref14.ws,
            login_ws = _ref14.login,
            page = _ref14.page;

        (({
            cms: init_cms,
            create: init_create,
            edit: init_edit,
            login: init_login,
            users: init_users
        })[page] || noop)(url_ws, login_ws, page);

        app_login_link.on({
            click: function (ev) {
                if (app_login_link_handler) {
                    app_login_link_handler(ev);
                } else {
                    ev.preventDefault();
                    init_login('', login_ws);
                }
            }
        });
    }, 4);

    /* ./vk/static_src/app/090_init.js }}} */

    /* {{{ ./vk/static_src/app/095_piwik.js */

    (function () {
        var piwik = 'https://bib.vetmed.fu-berlin.de/piwik/piwik.';

        window._paq = [['trackPageView'], ['enableLinkTracking'], ['setSiteId', 1], ['setTrackerUrl', piwik + 'php']];

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = piwik + 'js';
        (document.head || document.querySelector('head') || document.firstChild).appendChild(script);
    })();

    /* ./vk/static_src/app/095_piwik.js }}} */
})(window, document, $);
